import { Button, Form, Modal, Select } from 'antd';
import { useChangeResponsibleMutation } from 'app/services/edpApiV1/vacations';
import React, { useState } from 'react';
import { RolesUser } from 'shared/enums';
import { RolesToRussian } from 'shared/enums/rolesUser';
import { useNotifications } from 'shared/hooks/use-notifications';

type TProps = {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  allSubordinates: {
    id: number;
    lastName: string | null;
    middleName: string | null;
    name: string | null;
    organizationId: string | null;
    roleName: string | null;
  }[];
  requestId: number;
  vacationHrId?: number | null;
};

const ModalVacationsSubordinates = ({ allSubordinates, openModal, setOpenModal, requestId, vacationHrId }: TProps) => {
  const [trigger, result] = useChangeResponsibleMutation();
  const [stateBtn, setStateBtn] = useState<boolean>(true);
  const [form] = Form.useForm();
  const { isSuccess, isError, reset } = result;

  const handleOk = () => {
    setOpenModal(false);
  };

  const handleCancel = () => {
    setOpenModal(false);
    form.resetFields();
    setStateBtn(true);
  };

  const onSelect = (hrId: number) => {
    setStateBtn(false);
    if (vacationHrId === hrId) setStateBtn(true);
  };

  const onFinish = (values: { hrId: number }) => {
    const { hrId } = values;
    const bodyRequest = {
      hrId,
      requestId,
    };
    trigger(bodyRequest);
    form.resetFields();
    setStateBtn(true);
    setOpenModal(false);
  };

  useNotifications(isSuccess, isError, 'Ответственный назначен', 'Что-то пошло не так', reset);

  return (
    <Modal
      title="Выберите ответственного сотрудника"
      footer={false}
      onOk={handleOk}
      onCancel={handleCancel}
      visible={openModal}
      destroyOnClose={true}
    >
      <Form form={form} name="rejectionForm" onFinish={onFinish}>
        <Form.Item
          name="hrId"
          rules={[
            {
              validator: async (_, v) => {
                if (v === vacationHrId) return Promise.reject();
              },
              message: 'Выберите нового ответственного',
            },
          ]}
        >
          <Select placeholder="Выберите из списка" onSelect={onSelect}>
            {[
              ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.SecondLine]),
              ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.FirstLine]),
              ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.Consultant]),
              ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.Employee]),
            ].map(({ id, name, middleName, lastName }) => (
              <Select.Option key={id} value={id}>
                {`${lastName} ${name} ${middleName ?? ''}`}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary" disabled={stateBtn}>
            Назначить
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalVacationsSubordinates;
